//department-add-edit.js
import React from 'react'

const DepartmentAddEdit = () => {
	return <div>DepartmentAddEdit</div>
}

export default DepartmentAddEdit
